export default {
  colors: {
    default: '#344675',
    primary: '#42b883',
    info: '#1d8cf8',
    danger: '#fd5d93',
    orange: '#ff8a76',
    teal: '#00d6b4',
    white: '#ffffff',
    primaryGradient: [
      'rgba(76, 211, 150, 0.5)',
      'rgba(53, 183, 125, 0.1)',
      'rgba(119,52,169,0)'
    ],
    pinkGradient: [
      'rgba(255, 255, 255, 0.1)',
      'rgba(187,72,176, 0.5)',
      'rgba(187,72,176,1.0)'
    ],
    purpleGradient: ['rgba(253,93,147,0.8)', 'rgba(253,93,147,0)']
  }
};
